import React from 'react';
import { Row, Col, Anchor, Icon} from 'antd';
import './ApplicationHeader.css';
import patent1Img from '../../images/500/businessman-2682712_1920.jpg';

const ApplicationHeader = (props) => {
   return (
    <div className="ApplicationHeader--container">

      <div className="ApplicationHeader--container-inner">
               <div className="ApplicationHeader--subnavbar-container">
                  </div>
        <div className="ApplicationHeader--headline">
          
       </div>
       <div className="ApplicationHeader--body-text center">
       
          <h3 className="ApplicationHeader--body-text-headline-mobile font-special-heading">Applications &amp; Use Cases</h3>
         <p>
         Real Time Touch: has been granted key patents for technologies which could revolutionize telehealth and telemedicine.
         </p>
         <p>
         Seeking partners to develop this innovative mobile health patent in a multibillion dollar growing market.
         </p>
         
         <Row className="ApplicationHeader--row1">
          <Col xs={22} sm={16} md={12} lg={8}>
            <div className="ApplicationHeader--img-holder">
            <Anchor affix={false} offsetTop="70"><Anchor.Link href="#Global-Network" title={
              <img 
              className="ApplicationHeader--img img-responsive img-rounded-more" 
              src={patent1Img} 
              alt="Global Network" />
            } /></Anchor>

                <div className="clearfix ApplicationHeader-text-subimg">Worldwide</div>
            </div>   
          </Col> 
          <Col xs={22} sm={16} md={12} lg={8}>
            <div className="ApplicationHeader--img-holder">
            <Anchor affix={false} offsetTop="70">
              <Anchor.Link href="#Humanitarian" title={<img 
                className="ApplicationHeader--img img-responsive img-rounded-more" 
                src="https://www.realtimetouch.com/images/500/humanitarian-2723672_1920(1.jpg"
                alt="Humantitarian"/>
            } /></Anchor>
                <div className="clearfix ApplicationHeader-text-subimg">NGOs, International Development </div>
            </div>   
          </Col>
          <Col xs={22} sm={16} md={12} lg={8}>
            <div className="ApplicationHeader--img-holder">
            <Anchor affix={false} offsetTop="70"><Anchor.Link href="#Remote-Diagnostics" title={
              <img 
              className="ApplicationHeader--img img-responsive img-rounded-more" 
              src="https://www.realtimetouch.com/images/500/human-skeleton-163715.jpg" 
              alt="Remote Diagnostics"
              />
            } /></Anchor>
            

                <div className="clearfix ApplicationHeader-text-subimg">Remote Diagnostics</div>
            </div>       
          </Col>
        </Row>

        <Row>
          <Col lg={24}>
              <p>Scroll down for more info</p>
              <Icon type="caret-down" className="Header--box-icon-caretdown" style={{ color:"#CE001B", fontSize:22 }} />
          </Col>
        </Row>

       </div>
        
      </div>
      </div>
    )
 }
 export default ApplicationHeader;


// WEBPACK FOOTER //
// ./src/containers/ApplicationHeader/ApplicationHeader.js